import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from './Axios/api';
import Select from 'react-select';
import { Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';

const PurchaseEdit = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({});
    const [purchaseDetails, setPurchaseDetails] = useState([]);
    const [parties, setParties] = useState([]);
    const [brands, setBrands] = useState([]);

    const [editModes, setEditModes] = useState(purchaseDetails.map(() => false));

    const [itemGroups, setItemGroups] = useState([]);
    const [items, setItems] = useState([]);

    const [formDataItem, setFormDataItem] = useState({
        itemGroupId: '',
        itemId: '',
        currStock: '',
        reqQty: '',
        placeOfUse: '',
        remark: ''
    })

    const getDetails = async () => {
        try {
            const res = await api.get(`/purchase/return-indent-item-detail/${id}`);
            const data = res.data[0];

            setFormData(data || {});
            setPurchaseDetails(data.purchase_info || []);

            await getItemGroups();

            setFormDataItem({
                itemGroupId: data?.item_group || '',
                itemId: data?.item_name || '',
                currStock: data?.current_stock || '',
                reqQty: data?.required_qty || '',
                placeOfUse: data?.place_of_use || '',
                remark: data?.remark || ''
            });

            return data;

        } catch (error) {
            console.log(error);
        }
    };


    const getParty = async () => {
        try {
            const res = await api.get(`vendor/get-name`)
            const data = res.data;

            const newArr = data.map((party, index) => {
                let val = party._id;
                return { label: party.vendor_name, value: val }
            })
            setParties(newArr)
        } catch (error) {
            console.log(error.response.data)
        }
    }

    const getBrands = async () => {
        try {
            const res = await api.get(`brand/get`);
            const data = res.data;

            const newArr = data.map((brand, index) => {
                let val = brand._id
                return { label: brand.brand_name, value: val }
            });
            setBrands(newArr);
        } catch (error) {
            console.log(error.response.data);
        }
    }

    const getItemGroups = async () => {
        try {
            const res = await api.get(`/purchase-item-category/get`);
            setItemGroups(res.data);
        } catch (error) {
            console.log(error.response.data);
        }
    }

    const getItemsByGroup = async (groupId) => {
        try {
            const factoryId = formData.indent_branch;

            const res = await api.get(`/purchase-item/get-item-by-catloc?catId=${groupId}&factory=${factoryId}`);

            const itemOptions = res.data.map(item => ({
                label: item.item_title,
                value: item._id
            }));

            setItems(itemOptions);

            const isExistingValid = itemOptions.some(opt => opt.value === formDataItem.itemId);
            if (!isExistingValid) {
                setFormDataItem(prev => ({ ...prev, itemId: '' }));
            }

        } catch (err) {
            console.error("Failed to fetch items:", err);
        }
    };

    const handleChangePurchase = (index, field, value) => {

        const updatedDetails = [...purchaseDetails];
        const item = updatedDetails[index];

        item[field] = value;

        if (field === 'rate') {
            const rate = parseFloat(value) || 0;
            const qty = parseFloat(item.purchase_qty) || 0;
            const gst = parseFloat(formData.item_gst) || 0;

            const totalWithoutGST = rate * qty;
            const totalWithGST = totalWithoutGST + (totalWithoutGST * gst / 100);

            item.total_without_gst = Math.round(totalWithoutGST);
            item.total_with_gst = Math.round(totalWithGST);
        }

        updatedDetails[index] = item;
        setPurchaseDetails(updatedDetails);
    };

    const handleFormDataItemChange = (field, value) => {
        setFormDataItem(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async (index) => {
        try {
            const payload = purchaseDetails[index];

            const purchaseId = payload._id;

            const res = await api.patch(`/purchase/edit-addrate-party-details/${purchaseId}`, payload);

            if (res.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Updated!',
                    text: 'Purchase indent updated successfully!',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed!',
                    text: 'Failed to update purchase indent.',
                });
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong. Try again later.',
            });
        }
    };

    const handleItemSave = async () => {
        try {
            const updatePayload = {};

            if (formDataItem.itemGroupId) updatePayload.item_group = formDataItem.itemGroupId;
            if (formDataItem.itemId) updatePayload.item_name = formDataItem.itemId;
            if (formDataItem.currStock) updatePayload.current_stock = formDataItem.currStock;
            if (formDataItem.reqQty) updatePayload.required_qty = formDataItem.reqQty;
            if (formDataItem.placeOfUse) updatePayload.place_of_use = formDataItem.placeOfUse;
            if (formDataItem.remark) updatePayload.remark = formDataItem.remark;

            const res = await api.patch(`/indent/update-indent-item/${formData._id}`, updatePayload);

            if (res.status === 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Item updated successfully',
                    timer: 2000,
                    showConfirmButton: false,
                });
                const updatedData = await getDetails();
                if (updatedData?.item_gst) {
                    const x = await api.patch(`/purchase/edit-return-indent-item-detail/${formData._id}`, {
                        item_gst: updatedData.item_gst,
                    });
                    await getDetails();
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: 'Item update failed',
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong',
            });
        }
    };

    useEffect(() => {
        getDetails();
        getParty();
        getBrands();
        getItemGroups();
    }, [id])

    useEffect(() => {
        if (formDataItem.itemGroupId && formData.indent_branch) {
            getItemsByGroup(formDataItem.itemGroupId);
        }
    }, [formDataItem.itemGroupId, formData.indent_branch]);

    useEffect(() => {
        if (purchaseDetails.length > 0 && editModes.length === 0) {
            setEditModes(purchaseDetails.map(() => false));
        }
    }, [purchaseDetails]);

    return (
        <div className=" w-[90%] mt-5 mx-auto p-4 bg-gray-50">

            <div className='w-full justify-between items-center flex flex-wrap'>
                {/* Item Group */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="itemGroupId">Item Group</label>
                    <Select
                        options={itemGroups.map(group => ({
                            label: group.itemcat_title,
                            value: group._id
                        }))}
                        value={
                            itemGroups
                                .map(group => ({
                                    label: group.itemcat_title,
                                    value: group._id
                                }))
                                .find(opt => opt.value === formDataItem.itemGroupId) || null
                        }
                        onChange={(e) => handleFormDataItemChange('itemGroupId', e.value)}
                        placeholder="Select Item Group"
                        styles={{
                            menuList: () => ({
                                overflowY: "scroll",
                                maxHeight: "200px",
                            }),
                            input: (base) => ({ ...base, width: "180px" }),
                            placeholder: (base) => ({ ...base, color: "black" })
                        }}
                    />

                </div>

                {/* Item Name */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="itemId">Item Name</label>
                    <Select
                        options={items}
                        value={items.find(opt => opt.value === formDataItem.itemId) || null}
                        onChange={(e) =>
                            setFormDataItem(prev => ({ ...prev, itemId: e.value }))
                        }
                        placeholder="Select Item"
                        styles={{
                            menuList: () => ({
                                overflowY: "scroll",
                                maxHeight: "200px",
                            }),
                            input: (base) => ({ ...base, width: "180px" }),
                            placeholder: (base) => ({ ...base, color: "black" })
                        }}
                    />
                </div>

                {/* Curr Stock */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="currStock">Curr Stock</label>
                    <input
                        type="number"
                        className="block rounded outline-none border-1 py-1.5 pl-2 text-gray-700 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                        value={formDataItem.currStock}
                        onChange={(e) => handleFormDataItemChange('currStock', e.target.value)}
                    />
                </div>

                {/* Req Qty */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="reqQty">Req Qty</label>
                    <input
                        type="number"
                        className="block rounded outline-none border-1 py-1.5 pl-2 text-gray-700 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                        value={formDataItem.reqQty}
                        onChange={(e) => handleFormDataItemChange('reqQty', e.target.value)}
                    />
                </div>

                {/* Place of Use */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="placeOfUse">Place of Use</label>
                    <input
                        type="text"
                        className="block rounded outline-none border-1 py-1.5 pl-2 text-gray-700 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                        value={formDataItem.placeOfUse}
                        onChange={(e) => handleFormDataItemChange('placeOfUse', e.target.value)}
                    />
                </div>

                {/* Remark */}
                <div className='flex flex-col items-start justify-center p-3'>
                    <label htmlFor="remark">Remark</label>
                    <input
                        type="text"
                        className="block rounded outline-none border-1 py-1.5 pl-2 text-gray-700 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 sm:text-sm"
                        value={formDataItem.remark}
                        onChange={(e) => handleFormDataItemChange('remark', e.target.value)}
                    />
                </div>

                {/* Save Button */}
                <div className='flex justify-center items-center'>
                    <button
                        className='px-4 py-2 m-2 bg-blue-600 text-white rounded'
                        onClick={handleItemSave}
                    >
                        Save
                    </button>
                </div>

                <hr className='underline w-full' />
            </div>

            <div className="flex flex-wrap gap-5 mx-2 mt-6 mb-2">
                {purchaseDetails &&
                    purchaseDetails.map((purchaseDetails, index) => {
                        const isEditing = editModes[index];

                        return (
                            <div
                                key={index}
                                className="flex-1 min-w-full sm:min-w-[48%] lg:min-w-[32%] bg-white p-6 rounded shadow-lg"
                            >
                                <h2 className="text-lg font-semibold mb-4">Purchase Details</h2>

                                <div className="space-y-6">
                                    {/* Editable Fields */}
                                    <div className="p-4 bg-white border border-blue-200 rounded-md shadow-sm">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {/* Select Party */}
                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Select Party</label>
                                                <Select
                                                    options={parties}
                                                    value={{ value: purchaseDetails?.party_name, label: purchaseDetails?.party_name }}
                                                    onChange={(selectedOption) => {
                                                        if (!isEditing) return;
                                                        handleChangePurchase(index, 'party', selectedOption.value);
                                                        handleChangePurchase(index, 'party_name', selectedOption.label);
                                                    }}
                                                    isDisabled={!isEditing}
                                                />
                                            </div>

                                            {/* Brand */}
                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Brand</label>
                                                <Select
                                                    options={brands}
                                                    value={purchaseDetails?.brand_name}
                                                    onChange={(selectedOption) => {
                                                        if (!isEditing) return;
                                                        handleChangePurchase(index, 'brand', selectedOption.value);
                                                        handleChangePurchase(index, 'brand_name', selectedOption.label);
                                                    }}
                                                    isDisabled={!isEditing}
                                                />
                                            </div>

                                            {/* Discount */}
                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Discount</label>
                                                <input
                                                    type="number"
                                                    className="border w-full p-2 rounded-md"
                                                    value={purchaseDetails?.discount}
                                                    onChange={(e) => handleChangePurchase(index, 'discount', e.target.value)}
                                                    placeholder="Discount"
                                                    disabled={!isEditing}
                                                />
                                            </div>

                                            {/* Rate */}
                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Rate</label>
                                                <input
                                                    type="number"
                                                    className="border w-full p-2 rounded-md"
                                                    value={purchaseDetails?.rate}
                                                    onChange={(e) => handleChangePurchase(index, 'rate', e.target.value)}
                                                    placeholder="Rate"
                                                    disabled={!isEditing}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Read-only Fields */}
                                    <div className="p-4 bg-gray-50 border border-gray-200 rounded-md shadow-sm">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Split Quantity</label>
                                                <input
                                                    type="number"
                                                    className="border w-full p-2 bg-gray-100 rounded-md text-gray-600"
                                                    value={purchaseDetails?.splitQuantity}
                                                    disabled
                                                />
                                            </div>

                                            <div>
                                                <label className="block mb-1 text-sm font-medium">GST</label>
                                                <input
                                                    type="text"
                                                    className="border w-full p-2 bg-gray-100 rounded-md text-gray-600"
                                                    value={formData.item_gst}
                                                    disabled
                                                />
                                            </div>

                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Grand Total (Without GST)</label>
                                                <input
                                                    type="number"
                                                    className="border w-full p-2 bg-gray-100 rounded-md text-gray-600"
                                                    value={purchaseDetails?.total_without_gst}
                                                    disabled
                                                />
                                            </div>

                                            <div>
                                                <label className="block mb-1 text-sm font-medium">Grand Total (With GST)</label>
                                                <input
                                                    type="number"
                                                    className="border w-full p-2 bg-gray-100 rounded-md text-gray-600"
                                                    value={purchaseDetails?.total_with_gst}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Button */}
                                <div className="flex justify-end mt-4">
                                    {isEditing ? (
                                        <button
                                            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                                            onClick={() => {
                                                handleSave(index);
                                                const updatedModes = [...editModes];
                                                updatedModes[index] = false;
                                                setEditModes(updatedModes);
                                            }}
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                            onClick={() => {
                                                const updatedModes = [...editModes];
                                                updatedModes[index] = true;
                                                setEditModes(updatedModes);
                                            }}
                                        >
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}

            </div>

        </div>
    );
};


export default PurchaseEdit